import React from 'react';
import {IconProps} from './IconProps';

export default function CloseModalIcon(props: IconProps) {
  const {style, width = 14, height = 14, color = '#161719'} = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M6.11599 7L0.370901 12.7451L1.25478 13.629L6.99988 7.88389L12.7452 13.6292L13.6291 12.7453L7.88376 7L13.6292 1.25461L12.7453 0.370728L6.99988 6.11612L1.25473 0.370975L0.37085 1.25486L6.11599 7Z"
        fill={color}
      />
    </svg>
  );
}
